import { __awaiter } from "tslib";
import React from 'react';
import { parse } from 'query-string';
import TableOfContentsControl from '../controls/TableOfContentsControl';
import { Routes } from '../Routing';
import LabSimService, { StateContext } from '../services/LabSimService';
import PageFooter from '../partials/PageFooter';
import ProductVersionSelectorControl from '../controls/ProductVersionSelectorControl';
import LoadingPage from './LoadingPage';
import { T } from '@testout/labsim-ui-atomics';
import styles from './CourseResourceSelect.module.less';
import { LatestResourceType } from '../helpers/ResourceHelper';
export default class CourseResourceSelect extends React.Component {
    constructor(props) {
        var _a, _b, _c;
        super(props);
        this.maxLinks = process.env.REACT_APP_MOODLE_MAX_LINKS !== undefined
            ? Number(process.env.REACT_APP_MOODLE_MAX_LINKS)
            : 0;
        this.onContinue = () => {
            this.props.history.push(Routes.CONFIRM, {
                isbn: this.isbn,
                product: this.state.currentProduct,
                productVersionId: this.state.currentVersionId,
                selectedResources: this.state.selectedResources,
            });
        };
        this.goBack = () => {
            this.props.history.push(Routes.BROWSE);
            this.context.setUseLatestResource(false);
        };
        this.addOrRemoveLatestResource = (checked) => {
            if (checked) {
                const newSelectedResources = [
                    ...this.state.selectedResources,
                    this.state.latestResource,
                ];
                this.context.setUseLatestResource(checked);
                this.setState({
                    selectedResources: newSelectedResources,
                });
            }
            else {
                const newSelectedResources = this.state.selectedResources.filter((r) => r.resourceGuid !== this.state.latestResource.resourceGuid);
                this.context.setUseLatestResource(checked);
                this.setState({
                    selectedResources: newSelectedResources,
                });
            }
        };
        if (window.location.search !== null) {
            const queryParams = parse(window.location.search);
            this.isbn = queryParams.isbn;
            this.productId = queryParams.productId;
        }
        // if (!this.isbn) {
        //    // go back with message: ISBN invalid
        //    alert('No valid ISBN found');
        //    this.props.history.push(Routes.BROWSE);
        // }
        // see if there is state history we should be reloading with
        const selectedResources = ((_a = props.location.state) === null || _a === void 0 ? void 0 : _a.selectedResources) || [];
        const currentProduct = (_b = props.location.state) === null || _b === void 0 ? void 0 : _b.product;
        const currentVersionId = (_c = props.location.state) === null || _c === void 0 ? void 0 : _c.productVersionId;
        this.state = {
            currentProduct,
            currentVersionId,
            selectedResources,
            versionFixed: false,
            loading: true,
            selectedVersion: undefined,
        };
    }
    componentDidMount() {
        var _a;
        if ((_a = this === null || this === void 0 ? void 0 : this.context) === null || _a === void 0 ? void 0 : _a.products) {
            this.init();
        }
        else
            this.props.history.push(Routes.BROWSE);
    }
    init() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.context.onProductsLoaded();
            // get from state or fallback on default
            let currentVersion;
            let isFixedVersion = false;
            if ((_a = this.props.location.state) === null || _a === void 0 ? void 0 : _a.productVersionId) {
                currentVersion = (_b = this.props.location.state) === null || _b === void 0 ? void 0 : _b.productVersionId;
            }
            else {
                currentVersion = yield this.getProductVersion();
                isFixedVersion = currentVersion !== 0;
            }
            yield this.getProduct(currentVersion, isFixedVersion);
            this.setState({
                loading: false,
            });
        });
    }
    getProduct(versionId, versionFixed) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            let product;
            product = (_b = (_a = this.context.products) === null || _a === void 0 ? void 0 : _a.isbns) === null || _b === void 0 ? void 0 : _b.find((p) => (this.isbn != null && p.isbn === this.isbn) ||
                (this.productId != null && p.productId === this.productId));
            versionId =
                versionId ||
                    ((_c = product.versions.find((v) => product.version === v.version)) === null || _c === void 0 ? void 0 : _c.productVersionId);
            const version = (product === null || product === void 0 ? void 0 : product.versions.find((v) => v.productVersionId === versionId)) ||
                (product === null || product === void 0 ? void 0 : product.versions.find((v) => v.version === product.version));
            product = Object.assign(Object.assign({}, product), version);
            const filteredAndSortedVersions = product.versions
                .filter((v) => {
                if (this.context.lockedVersions && this.context.lockedVersions.length > 0) {
                    const matchingProduct = this.context.lockedVersions.find((l) => (l.isbn != null && l.isbn === product.isbn) ||
                        (l.productId != null && l.productId === product.productId));
                    if (matchingProduct != null) {
                        return v.productVersionId === matchingProduct.productVersionId;
                    }
                    return true;
                }
                return true;
            })
                .sort((a, b) => (a.version > b.version ? -1 : 1));
            const defaultLink = yield LabSimService.getDefaultResourceLink(product.productVersionId);
            const latestResource = {
                sectionNumber: LatestResourceType,
                sectionTitle: `${product.title} Progress Tracker`,
                resourceGuid: defaultLink.resourceId,
                possiblePoints: defaultLink.pointsPossible,
                type: LatestResourceType,
                hasVideos: false,
                hasSims: false,
                hasTextLessons: false,
                hasDemos: false,
                hasExams: false,
                isGradable: false,
                addGradeColumn: false,
            };
            const resourceSelectedVersion = (filteredAndSortedVersions === null || filteredAndSortedVersions === void 0 ? void 0 : filteredAndSortedVersions.length) === 1
                ? filteredAndSortedVersions[0]
                : versionId != null
                    ? filteredAndSortedVersions === null || filteredAndSortedVersions === void 0 ? void 0 : filteredAndSortedVersions.find((a) => a.productVersionId === versionId)
                    : filteredAndSortedVersions === null || filteredAndSortedVersions === void 0 ? void 0 : filteredAndSortedVersions[0];
            this.setState({
                currentProduct: product,
                currentVersionId: product.productVersionId,
                versionFixed: versionFixed,
                availableVersions: filteredAndSortedVersions,
                latestResource: latestResource,
                selectedVersion: resourceSelectedVersion,
            });
        });
    }
    getProductVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            let activeVersionInfo;
            if (this.isbn != null && this.isbn !== '')
                activeVersionInfo = yield LabSimService.getCampusActiveProductVersionIsbn(this.isbn);
            else
                activeVersionInfo = yield LabSimService.getCampusActiveProductVersion(this.productId);
            return activeVersionInfo.currentVersion;
        });
    }
    render() {
        if (this.state.loading) {
            return React.createElement(LoadingPage, { status: 'Fetching and parsing product Chapters and Sections...' });
        }
        return (React.createElement(StateContext.Consumer, null, (stateContext) => {
            var _a, _b, _c, _d, _e, _f, _g;
            return (React.createElement("div", { className: styles.container },
                React.createElement(T.Text.H1, { automationId: 'title', variation: T.Text.Variation.H1_Large, className: styles.header }, "Create Links to Resources"),
                React.createElement(T.Text.H2, { automationId: 'productInfo', className: styles.versionInfo },
                    React.createElement("div", { className: styles.productTitle }, (_a = this.state.currentProduct) === null || _a === void 0 ? void 0 :
                        _a.title,
                        " (", (_b = this.state.currentProduct) === null || _b === void 0 ? void 0 :
                        _b.isbn,
                        ")"),
                    React.createElement("div", null,
                        `\t${((_c = this.state.currentProduct) === null || _c === void 0 ? void 0 : _c.language) || ''}`,
                        ` ${((_d = this.state.selectedVersion) === null || _d === void 0 ? void 0 : _d.version) ||
                            ((_e = this.state.currentProduct) === null || _e === void 0 ? void 0 : _e.version) ||
                            ''}`)),
                this.state.availableVersions && ((_f = this.state.availableVersions) === null || _f === void 0 ? void 0 : _f.length) > 1 && (React.createElement(ProductVersionSelectorControl, { currentProduct: this.state.currentProduct, availableVersions: this.state.availableVersions, versionFixed: this.state.versionFixed, onChange: (versionId) => this.getProduct(versionId, false) })),
                React.createElement(T.InfoBox, { automationId: 'selectInfo', className: styles.info },
                    React.createElement(T.InfoBox.Body, { iconVariation: T.IconVariation.InfoCircle }, stateContext.isFamilyMoodle() && this.maxLinks > 0
                        ? `Moodle only allows ${this.maxLinks} assignments to be created at a time.`
                        : 'An assignment will be created for each topic you select.')),
                this.state.currentProduct && (React.createElement(React.Fragment, null,
                    stateContext.isIntegrationLTIAdvantage() && (React.createElement(T.Container, null,
                        React.createElement(T.Input.Checkbox, { name: 'latest', checked: this.context.useLatestResource ||
                                this.state.selectedResources.find((s) => s.sectionNumber === LatestResourceType) != null, onChange: this.addOrRemoveLatestResource, className: styles.latestResource },
                            React.createElement(T.Text.Span, { automationId: '' },
                                "Include \"",
                                this.state.currentProduct.title,
                                " Progress Tracker\" link"),
                            React.createElement(T.Popover, { automationId: 'help-popover', placement: 'bottom-end' },
                                React.createElement(T.Popover.Trigger, null,
                                    React.createElement(T.IconButton, { automationId: 'help-button', iconVariation: T.IconVariation.InfoCircle, screenReaderDescription: 'Progress link', className: styles.lastLocationIconButton })),
                                React.createElement(T.Popover.Content, null,
                                    React.createElement("div", { className: styles.lastLocationPopover }, "The \"Progress Tracker\" helps students keep track of course progress and set goals for this course.")))))),
                    React.createElement(TableOfContentsControl, { availableVersions: this.state.availableVersions, defaultSelectedResources: this.state.selectedResources, currentProduct: this.state.currentProduct, selectedVersion: (_g = this.state.selectedVersion) === null || _g === void 0 ? void 0 : _g.productVersionId, onSelectionChange: (selectedResources) => {
                            if (this.context.useLatestResource &&
                                selectedResources.find((s) => s.sectionNumber === LatestResourceType) == null) {
                                selectedResources.push(this.state.latestResource);
                            }
                            this.setState({ selectedResources: selectedResources });
                        } }))),
                stateContext.isFamilyCanvas() && (React.createElement(T.InfoBox, { automationId: 'proTip', className: styles.tip },
                    React.createElement(T.InfoBox.Body, { iconVariation: T.IconVariation.Lightbulb, prefix: 'Pro Tip!' }, "Being selective with your course links will help keep students engaged and reduce load times. We recommend starting with practice questions and labs."))),
                React.createElement(T.ActionToolbar, { className: styles.toolbar },
                    React.createElement(T.ActionToolbar.Group, { right: true, className: styles.toolbarGroup },
                        React.createElement(T.Button, { automationId: 'backBtn', onClick: this.goBack, variation: T.ButtonVariation.Secondary }, "Back"),
                        React.createElement("div", null,
                            React.createElement(T.Button, { disabled: this.state.selectedResources.length === 0 ||
                                    (stateContext.isFamilyMoodle() &&
                                        this.maxLinks > 0 &&
                                        this.state.selectedResources.length > this.maxLinks), automationId: 'continueBtn', className: styles.contBtn, onClick: this.onContinue },
                                "Continue",
                                stateContext.isFamilyMoodle() && this.maxLinks > 0 && (React.createElement(T.Text.P, { automationId: 'selectedCount', variation: T.Text.Variation.Smallest },
                                    this.state.selectedResources.length,
                                    "/",
                                    this.maxLinks,
                                    ' ',
                                    "selected")))))),
                React.createElement(PageFooter, null)));
        }));
    }
}
CourseResourceSelect.contextType = StateContext;
//# sourceMappingURL=CourseResourceSelect.js.map